import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { buildGarageMobileSearchPath } from "../utility/garageMobileSearch";

const MobileSearchBar = ({ podiumId, locationId, initialMobile = "", className = "", showReset = false }) => {
    const history = useHistory();
    const [mobile, setMobile] = useState(initialMobile);
    const hasActiveSearch = Boolean(String(initialMobile || "").trim());

    useEffect(() => {
        setMobile(initialMobile || "");
    }, [initialMobile]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!mobile.trim()) return;
        const path = buildGarageMobileSearchPath({ mobile, podiumId, locationId });
        history.push(path);
    };

    const handleReset = () => {
        setMobile("");
        const path = buildGarageMobileSearchPath({ mobile: "", podiumId, locationId });
        history.push(path);
    };

    return (
        <form
            className={`garage-mobile-search-form ${className}`.trim()}
            onSubmit={handleSubmit}>
            <input
                type="tel"
                placeholder="Mobile partial or full search"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className="garage-input"
                style={{ width: "50vw" }}
            />
            <button
                className="garage-btn garage-btn-blue"
                type="submit">
                Find
            </button>
            {showReset && (
                <button
                    className="garage-btn garage-btn-reset"
                    type="button"
                    onClick={handleReset}
                    disabled={!hasActiveSearch && !mobile.trim()}>
                    Reset
                </button>
            )}
        </form>
    );
};

export default MobileSearchBar;
